<template>

  <div class="relative p-4">
    <div class="flex items-center">
      <img class="w-14 rounded-lg shadow-lg" src="../../assets/img/placeholder_avatar.png" alt="">
      <div class="mr-4">
        <h3>{{ user.name }}</h3>
        <h6 class="mt-2">
          موجودی:
          {{ $helper.priceFormatter(credit) }}
        </h6>
        <!--        <span class="text-sm mt-2">-->
        <!--          موجودی:-->
        <!--          <span class="text-green-500">20,000</span>-->
        <!--          تومان</span>-->
      </div>
    </div>

    <hr class="border-brand/50 my-4">

    <!--    <ProfileCard title="ویرایش اطلاعات" to="/profile/edit">-->
    <!--      <UserIcon class="text-brand w-6 h-6"/>-->
    <!--    </ProfileCard>-->

    <ProfileCard :title="$t('profile_requests_list')" to="/profile/service-request">
      <CollectionIcon class="text-brand w-6 h-6"/>
    </ProfileCard>

    <ProfileCard :title="$t('profile_invoices_list')" to="/profile/orders">
      <CashIcon class="text-brand w-6 h-6"/>
    </ProfileCard>

    <!--    <ProfileCard title="پیام ها" to="#">-->
    <!--      <ChatIcon class="text-brand w-6 h-6"/>-->
    <!--    </ProfileCard>-->

    <!--    <ProfileCard title="نظرسنجی" to="#">-->
    <!--      <ChatAlt2Icon class="text-brand w-6 h-6"/>-->
    <!--    </ProfileCard>-->

    <div class="flex items-center p-2 rounded-lg mt-4" @click="logout()"
         @touchstart="toggleAnimation" @touchend="toggleAnimation">
      <div class="bg-red-500/20 rounded-lg p-1 shadow">
        <LogoutIcon class="text-red-500 w-6 h-6"/>
      </div>
      <span class="mr-4 text-red-500">{{ $t('logout') }}</span>
      <ChevronLeftIcon class="text-red-500 w-5 h-5 mr-auto"/>
    </div>

    <!--    <div class="flex justify-center items-center w-full h-20 bg-brand/20 text-brand rounded-lg mt-8">-->
    <!--      <SupportIcon class="h8 w-8 ml-2"/>-->
    <!--      تماس با پشتیبانی-->
    <!--    </div>-->

  </div>
</template>

<script>
import {CashIcon, CollectionIcon} from "@heroicons/vue/solid";
import ProfileCard from "@/components/User/ProfileCard";
import {ChevronLeftIcon, LogoutIcon} from "@heroicons/vue/outline";
import {getUser, getUserCredit} from "@/API/API";
import {mapState} from "vuex";

export default {
  name: "ProfilePage",
  components: {
    ProfileCard, CollectionIcon, CashIcon, LogoutIcon, ChevronLeftIcon
  },
  data() {
    return {
      credit: ''
    }
  },
  computed: {
    ...mapState(['user'])
  },
  async created() {
    this.$store.dispatch('setUser', (await getUser()).data)

    const {data} = await getUserCredit(100, 200);
    this.credit = data.result
  },
  methods: {
    toggleAnimation(event) {
      event.currentTarget.classList.toggle('bg-red-500/20')
    },
    logout() {
      this.$store.dispatch('logout')
    }
  }
}
</script>

<style scoped>

</style>